import { COOKIES_KEYS } from '../../constants';
import { getCookie } from '../cookies';

const getCountryIdFromCookie = () =>
  getCookie(COOKIES_KEYS.TEST_COUNTRY_ID, undefined) ||
  getCookie(COOKIES_KEYS.COUNTRY_ID, undefined);

export default getCountryIdFromCookie;
